module.exports = __webpack_public_path__ + "static/img/img_1.5b7dc12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_resource_management/img_1.jpg
// module id = 30h+
// module chunks = 0